import { AddToCartUrlContextParam } from '../../cart/shop-cart/interfaces/shop-cart.interface';
import { html } from 'lit';

export declare interface FreeTrialConversionProduct {
  isbn: string;
  requestProduct: AddToCartUrlContextParam;
}

export const FREE_TRIAL_CONVERTED_MSG = html`
  <span><b>Your cart has been updated:</b> Prices are updated to reflect your free trial eligibility.</span>
`;

export const FREE_TRIAL_INTL_CONVERTED_MSG = html`
  <span>
    <b>Your cart has been updated:</b> Prices are updated to reflect your free trial eligibility. Free trials are only
    available to US customers.
  </span>
`;
